var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useContext } from "react";
import { RicosContext } from "./../ricos-context";
import { IFRAME_COMPONENT } from "./dataHooks";
import styles from "./statics/styles/Iframe-scss";
const Iframe = (_a) => {
  var _b = _a, {
    iframeRef,
    isViewer
  } = _b, otherProps = __objRest(_b, [
    "iframeRef",
    "isViewer"
  ]);
  const { tabIndex } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    __spreadProps(__spreadValues({
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      "data-hook": IFRAME_COMPONENT,
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay; encrypted-media" : "fullscreen; encrypted-media",
      allowFullScreen: true
    }, otherProps), {
      tabIndex
    })
  );
};
var Iframe_default = Iframe;
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe.js.map
